export const STATUS_BULKS_COMPLETED = "completed"
export const STATUS_BULKS_IN_PROGRESS = "in-progress"


// WEBPACK FOOTER //
// ./src/state/bulk-operation/BulkOperationsStatus.ts